export const Recaptcha = {
  LOW_SCORE: 'Recaptcha score is lower than threshold',
}
